import {
    USER_CHOOSE_CURRENT_FRUI_ZZZZ,
} from './constants';
  
export function chooseCurrentFrui_zzzz(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_ZZZZ,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_ZZZZ:
        return {
          ...state,
          frui_zzzzList:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_zzzz.js